import React from 'react';
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from 'recharts';
import { Card, Typography, Box, useTheme, useMediaQuery, alpha } from '@mui/material';

const ComparisonChart = ({ data }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <Card sx={{ p: { xs: 2, md: 4 }, height: '100%', borderRadius: 4, width: '100%', maxWidth: '100%' }}>
      <Box sx={{ mb: { xs: 2, md: 4 } }}>
        <Typography variant="h5" sx={{ fontWeight: 800, fontSize: { xs: '1.1rem', md: '1.5rem' } }}>Growth Comparison</Typography>
        <Typography variant="body2" color="text.secondary">Current vs Last Month Performance</Typography>
      </Box>
      <Box sx={{ height: { xs: 280, md: 400 }, width: '100%' }}>
        <ResponsiveContainer width="100%" height="100%">
          <BarChart
            data={data}
            margin={{ top: 20, right: isMobile ? 8 : 30, left: isMobile ? 0 : 20, bottom: 5 }}
            barGap={isMobile ? 4 : 8}
          >
            <CartesianGrid strokeDasharray="3 3" vertical={false} stroke="#F1F5F9" />
            <XAxis
              dataKey="name"
              axisLine={false}
              tickLine={false}
              tick={{ fill: '#64748B', fontSize: isMobile ? 10 : 13, fontWeight: 600 }}
              dy={10}
              interval={isMobile ? 'preserveStartEnd' : 0}
            />
            <YAxis
              axisLine={false}
              tickLine={false}
              tick={{ fill: '#64748B', fontSize: isMobile ? 10 : 12 }}
              width={isMobile ? 32 : 48}
            />
            <Tooltip
              cursor={{ fill: alpha('#919EAB', 0.08) }}
              contentStyle={{
                borderRadius: 12,
                backgroundColor: theme.palette.background.paper,
                border: `1px solid ${theme.palette.divider}`,
                boxShadow: '0 8px 16px rgba(20, 26, 56, 0.2)',
                fontSize: 14,
                fontWeight: 600
              }}
              labelStyle={{ color: theme.palette.text.primary, fontWeight: 700 }}
              itemStyle={{ color: theme.palette.text.secondary }}
            />
            <Legend
              verticalAlign="top"
              align={isMobile ? 'center' : 'right'}
              iconType="circle"
              wrapperStyle={{ paddingTop: 0, paddingBottom: isMobile ? 12 : 24, fontSize: isMobile ? 11 : 13 }}
            />
            <Bar
              name="Last Month"
              dataKey="last"
              fill={alpha(theme.palette.primary.main, 0.2)}
              radius={[4, 4, 0, 0]}
              barSize={isMobile ? 20 : 32}
            />
            <Bar
              name="Current Month"
              dataKey="current"
              fill={theme.palette.primary.main}
              radius={[4, 4, 0, 0]}
              barSize={isMobile ? 20 : 32}
            />
          </BarChart>
        </ResponsiveContainer>
      </Box>
    </Card>
  );
};

export default React.memo(ComparisonChart);
